//
// ./src/store/index.js
//
import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import user from './user'
import shared from './shared'
import firebasedata from './fbdata'
import tabsRow from './modules/tabsRow'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    user,
    shared,
    firebaseDataLayer: firebasedata,
    tabsRow
  },
  plugins: [
    createPersistedState({
      key: 'ak-vue-fire-md',
      paths: ['tabsRow']
    })
  ]
})
